import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { IHelpProbabilityElement } from 'src/app/core/models/front';
import { IHelpDataService } from 'src/app/core/services/core';

@Component({
  selector: 'howden-help-probability',
  templateUrl: './help-probability.component.html',
  styleUrls: ['./help-probability.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class HelpProbabilityComponent {
  private helpDataSrv = inject(IHelpDataService);

  public dataSource: IHelpProbabilityElement[] = [];
  public displayedColumns: string[] = ['clasification', 'value', 'frequency', 'example'];

  constructor() {
    this.dataSource = this.helpDataSrv.getDataHelpProbability();
  }
}
